import { Cloud } from '../types';

const LABEL: Record<Cloud, string> = { aws: 'AWS', azure: 'Azure' };

export function CloudPill({ cloud }: { cloud: Cloud }) {
  return (
    <span className={`cloud-pill ${cloud}`}>
      <span className="cloud-dot" />
      {LABEL[cloud]}
    </span>
  );
}
